import { lazy } from 'react';
import { getConf, ConfigurationReference, } from '@jbrowse/core/configuration';
import { getSession } from '@jbrowse/core/util';
import { types, getEnv } from 'mobx-state-tree';
// icons
import VisibilityIcon from '@mui/icons-material/Visibility';
// locals
import { BaseLinearDisplay } from '../BaseLinearDisplay';
const SetMaxHeightDlg = lazy(() => import('./components/SetMaxHeight'));
const stateModelFactory = (configSchema) => types
    .compose('LinearBasicDisplay', BaseLinearDisplay, types.model({
    type: types.literal('LinearBasicDisplay'),
    trackShowLabels: types.maybe(types.boolean),
    trackShowDescriptions: types.maybe(types.boolean),
    trackDisplayMode: types.maybe(types.string),
    trackMaxHeight: types.maybe(types.number),
    configuration: ConfigurationReference(configSchema),
}))
    .views(self => ({
    get rendererTypeName() {
        return getConf(self, ['renderer', 'type']);
    },
    get showLabels() {
        var _a;
        return (_a = self.trackShowLabels) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'showLabels']);
    },
    get showDescriptions() {
        var _a;
        return ((_a = self.trackShowDescriptions) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'showDescriptions']));
    },
    get maxHeight() {
        var _a;
        return (_a = self.trackMaxHeight) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'maxHeight']);
    },
    get displayMode() {
        var _a;
        return ((_a = self.trackDisplayMode) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'displayMode']));
    },
}))
    .views(self => ({
    get rendererConfig() {
        const configBlob = getConf(self, ['renderer']) || {};
        const config = configBlob;
        return self.rendererType.configSchema.create({
            ...config,
            showLabels: self.showLabels,
            showDescriptions: self.showDescriptions,
            displayMode: self.displayMode,
            maxHeight: self.maxHeight,
        }, getEnv(self));
    },
}))
    .actions(self => ({
    toggleShowLabels() {
        self.trackShowLabels = !self.showLabels;
    },
    toggleShowDescriptions() {
        self.trackShowDescriptions = !self.showDescriptions;
    },
    setDisplayMode(val) {
        self.trackDisplayMode = val;
    },
    setMaxHeight(val) {
        self.trackMaxHeight = val;
    },
}))
    .views(self => {
    const { trackMenuItems: superTrackMenuItems, renderProps: superRenderProps, } = self;
    return {
        renderProps() {
            const config = self.rendererConfig;
            const superProps = superRenderProps();
            const superPropsOmit = superProps;
            return {
                ...superPropsOmit,
                config,
            };
        },
        trackMenuItems() {
            return [
                ...superTrackMenuItems(),
                {
                    label: 'Show labels',
                    icon: VisibilityIcon,
                    type: 'checkbox',
                    checked: self.showLabels,
                    onClick: () => {
                        self.toggleShowLabels();
                    },
                },
                {
                    label: 'Show descriptions',
                    icon: VisibilityIcon,
                    type: 'checkbox',
                    checked: self.showDescriptions,
                    onClick: () => self.toggleShowDescriptions(),
                },
                {
                    label: 'Display mode',
                    icon: VisibilityIcon,
                    subMenu: [
                        'compact',
                        'reducedRepresentation',
                        'normal',
                        'collapse',
                    ].map(val => ({
                        label: val,
                        onClick: () => {
                            self.setDisplayMode(val);
                        },
                    })),
                },
                {
                    label: 'Set max height',
                    onClick: () => {
                        getSession(self).queueDialog(handleClose => [
                            SetMaxHeightDlg,
                            { model: self, handleClose },
                        ]);
                    },
                },
            ];
        },
    };
});
export default stateModelFactory;
//# sourceMappingURL=model.js.map